import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from '../services/data-sharing.service';
import { UserService } from '../services/user.service';
import { StudentService } from '../services/student.service';
import { ContactUsService } from '../services/contactus.service';

import { Location } from '../models/location';
import { ClassSchedule } from '../models/class-schedule';
import { ClassScheduleSession } from '../models/class-schedule-session';
import { StudentGet } from '../models/student-get';
import { ContactRequest } from '../models/contact-request';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {

  attendees: string = '';
  PayMsgSent: string = '';
  location: Location;
  classSchedule: ClassSchedule;
  classScheduleSessions: ClassScheduleSession[];
  student: StudentGet = new StudentGet();
  isStudent: boolean = false;
  formattedName: string;
  sending: boolean = false;
  paymentConfirmation: ContactRequest = new ContactRequest();
  paymentMessage: string = this._dataService.getFullPaymentMessage();

  constructor(private _dataService: DataSharingService,
    private _studentService:  StudentService,
    private _user: UserService,
    private _contactUsService: ContactUsService) { }

  onRdioChange(item){
    this.student.contactMethodId = item;
  }
  getData() {
    console.log('getting data...');
    const roleId = this._dataService.getRoleId();
    this.isStudent = (roleId === this._user.roleStudent);
    let location = this._dataService.getSelectedLocation();
    console.log('Location Name: ' + location.location.name);
    let classSchedule = this._dataService.getSelectedClassSchedule();

    if (location !== null) {
      this.location = location.location;
    } else {
      this.location = new Location;
    }

    if (classSchedule !== null) {
      this.classSchedule = classSchedule.classSchedule;
      this.classScheduleSessions = classSchedule.classSchedule.classScheduleSessions;
    } else {
      this.classSchedule = new ClassSchedule;
    }
    this.student = this._dataService.getCurrentStudent().student;
    this.get_attendees();
    // this.attendees = this.student.firstName.concat(' ').concat(this.student.lastName);
    // this.formattedName = this.student.firstName + ' '
    //   + ((this.student.middleName == null) ? '' : this.student.middleName + ' ')
    //   + this.student.lastName;
    // if ( this.student.friendStudent && this._dataService.getRegisterAdditional() ) {
    //   this.attendees = this.attendees + ' and ' + this.student.friendStudent.firstName + ' '
    //     + ((this.student.friendStudent.middleName == null) ? '' : this.student.friendStudent.middleName + ' ')
    //     + this.student.friendStudent.lastName + ' are ';
    // } else {
    //   this.attendees = this.attendees + ' is ';
    // }
  }

  get_attendees() {
    this.formattedName = this.student.firstName + ' '
      // + ((this.student.middleName == null) ? '' : this.student.middleName + ' ')
      + this.student.lastName;
    this.attendees = this.formattedName;
      if ( this.student.friendStudent && this._dataService.getRegisterAdditional() ) {
      this.attendees = this.attendees + ' and ' + this.student.friendStudent.firstName + ' '
        // + ((this.student.friendStudent.middleName == null) ? '' : this.student.friendStudent.middleName + ' ')
        + this.student.friendStudent.lastName + ' are ';
    } else {
      this.attendees = this.attendees + ' is ';
    }
  }

  send_email() {
    this.get_attendees();
    this.sending = true;
    // let bodyContents = document.getElementById('print-section').innerHTML;
    // bodyContents = `<html><body>${bodyContents}</body></html>`;
    this.paymentConfirmation = new ContactRequest();
    this.paymentConfirmation.name = this.student.firstName + ' ' + this.student.lastName;
    this.paymentConfirmation.phone = this.student.phone;
    this.paymentConfirmation.email = this.student.email;
    this.paymentConfirmation.message = '<p><b>' + this.attendees + 'confirmed for the following class:</b></p> ';
    this.paymentConfirmation.message = this.paymentConfirmation.message + '<table><tr><td><b>Date/Time:</b></td>' +
      '<td>' + this.classScheduleSessions[0].formattedDate + ' ' + this.classScheduleSessions[0].formattedTime + '</td></tr>';
    if (this.classScheduleSessions.length > 1 ) {
      this.paymentConfirmation.message +=
      '<tr><td></td><td>' + this.classScheduleSessions[1].formattedDate + ' ' + this.classScheduleSessions[1].formattedTime + '</td></tr>';
    }
    this.paymentConfirmation.message +=
      `<tr><td><b>Location:</b></td><td>${this.location.name}</td></tr><tr><td></td><td>${this.location.address.formattedAddress}</td></tr></table>`;
    const paymentMessage = this._dataService.getFullPaymentMessage();
    this.paymentConfirmation.message += '<br><b>' + paymentMessage + '<b>';
    this.paymentConfirmation.subject = 'Payment Confirmation';
    this._contactUsService.sendContactRequest(this.paymentConfirmation)
      .subscribe(
      res => this.sendEmailSuccess(res),
      error => this.sendEmailFailed(error),
      () => {
        console.log('ContactRequest Sent!');
      });
      // this._studentService.updateStudentEmail(this.student).subscribe(
      // res => this.saveSuccessful(res),
      // error => this.saveFailed(error),
      // () => console.log('Student Email Updated!'));
  }
  sendEmailSuccess(res: any) {
    this.sending = false;
    this.PayMsgSent = 'A confirmation email has been sent.';
    setTimeout(() => { this.PayMsgSent = ''; }, 4000);
  }
  sendEmailFailed(error: any) {
    this.sending = false;
  }

//  update_contactMethod(){
//         this._studentService.updateStudentContactMethod(this.student).subscribe(
//           res => this.saveSuccessful(res),
//           error => this.saveFailed(error),
//           () => console.log('Student contact method updated!'));
//   }
//   saveSuccessful(result: any) {}
//   saveFailed(result: any) {}

  print() {
    const bodyContents = document.getElementById('print-section').innerHTML;
    const popup = window.open('', '_blank', 'height=600,width=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popup.document.open();
    popup.document.write(`
      <html>
        <head>
          <title>Course Confirmation Details</title>
          <link rel="stylesheet" type="text/css" href="styles.css"> 
        </head>
        <body onload="window.print();window.close()">${bodyContents}</body>
      </html>`
    );
    popup.document.close();
  }

  ngOnInit() {
    this.getData();
  }

}



// WEBPACK FOOTER //
// ./src/app/payment-confirmation/payment-confirmation.component.ts